const setInvoice = (state, invoice) => {
  state.invoice = invoice;
};

export default {
  setInvoice,
};
